const s = {
  name: "BicycleParking",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M32.5,25c-0.6,0-1.3,0.1-1.9,0.2L28,18.8V18h4c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5h-1v2h1
			c1.9,0,3.5-1.6,3.5-3.5c0-1.9-1.6-3.5-3.5-3.5v0h-6v3.2l0.5,1.3H14.3l-1-2.5H15v-2H8v2h3.1l6.2,15h5.3L27,22.5h0.3l1.4,3.5
			c-2.3,1.3-3.8,3.7-3.8,6.5c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5S36.6,25,32.5,25z M21.3,31h-2.7l-3.5-8.5h9.7L21.3,31z M32.5,38
			c-3,0-5.5-2.5-5.5-5.5c0-1.9,1-3.6,2.5-4.6l2,5l1.9-0.8l-2-5c0.4-0.1,0.7-0.1,1.1-0.1c3,0,5.5,2.5,5.5,5.5S35.5,38,32.5,38z"/>
		<path class="st0" d="M7.5,25C3.4,25,0,28.4,0,32.5S3.4,40,7.5,40s7.5-3.4,7.5-7.5S11.6,25,7.5,25z M7.5,38c-3,0-5.5-2.5-5.5-5.5
			S4.5,27,7.5,27s5.5,2.5,5.5,5.5S10.5,38,7.5,38z"/>
		<path class="st0" d="M19.3,2h1.4l17.6,12.4l1.2-1.6L21.3,0h-2.6L0.6,12.8l1.2,1.6L19.3,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as BicycleParking
};
